import { render, staticRenderFns } from "./ChannelEndpointDialog.vue?vue&type=template&id=6716c3ad&scoped=true&"
import script from "./ChannelEndpointDialog.vue?vue&type=script&lang=ts&"
export * from "./ChannelEndpointDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelEndpointDialog.vue?vue&type=style&index=0&id=6716c3ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6716c3ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6716c3ad')) {
      api.createRecord('6716c3ad', component.options)
    } else {
      api.reload('6716c3ad', component.options)
    }
    module.hot.accept("./ChannelEndpointDialog.vue?vue&type=template&id=6716c3ad&scoped=true&", function () {
      api.rerender('6716c3ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_dialogs/ChannelEndpointDialog.vue"
export default component.exports